import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Dropdown } from 'react-toolbox';
import S from '../TemplateStyling.scss';

const itemOrLabor = [
  { value: 'Item', label: 'Item' },
  { value: 'Labor', label: 'Labor' },
];

// Must stay in sync with JobPaperworkTemplate::NUMERIC_FIELD_PATTERN
// (app/models/job_paperwork_template.rb), so a value accepted here is guaranteed to also pass
// the backend's stricter format check - otherwise a value like ".5", "5.", or "1e5" would pass
// Number()-based validation client-side but get rejected server-side, giving the user an
// unexplained error on submit.
export const NUMERIC_FIELD_PATTERN = /^-?\d+(\.\d+)?$/;

const STRICT_NUMBER_FIELDS = ['costToLowes', 'price_adjustment'];

export function validateLaborMaterials(labors_materials) {
  const errors = {};
  labors_materials.forEach((item, idx) => {
    const numberFields = ['qty', 'costToLowes', 'price_adjustment'];
    numberFields.forEach((field) => {
      const value = item[field];
      if (value === undefined || value === '') return;
      const isStrict = STRICT_NUMBER_FIELDS.includes(field);
      const isValidNumber = isStrict
        ? NUMERIC_FIELD_PATTERN.test(String(value))
        : !isNaN(Number(value));
      if (!isValidNumber) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} must be a number.`];
        return;
      }
      if (field === 'qty' && Number(value) === 0) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} cannot be 0, starts in a unit of 1.`];
        return;
      }
      if (isStrict && Number(value) !== Number(Number(value).toFixed(3))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} cannot have more than 3 decimal places.`];
      }
    });
  });
  if (Object.keys(errors).length > 0) {
    errors.laborMaterials = [
      'Please ensure all Qty and Cost fields are valid numbers.',
    ];
  }
  return errors;
}

function LaborMaterial({ labors_materials, onChange, canViewPriceAdjustment }) {
  const fieldErrors = validateLaborMaterials(labors_materials);

  const handleFieldChange = (idx, field, value) => {
    const updated = labors_materials.map((m, i) =>
      (i === idx ? { ...m, [field]: value } : m),
    );
    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...labors_materials,
      {
        itemOrLabor: '',
        qty: '',
        costToLowes: '',
        description: '',
        price_adjustment: '',
      },
    ]);
  };

  const removeRow = (idx) => {
    onChange(labors_materials.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <h6>Additional Labor/Material</h6>
      {labors_materials.map((item, idx) => {
        const rowErrors = fieldErrors[idx] || {};
        const costError = (rowErrors.costToLowes || [])[0];
        const priceAdjustmentError = (rowErrors.price_adjustment || [])[0];
        return (
          <div key={item.itemOrLabor || `additional-${idx}`} style={{ border: '1px solid #eee', marginBottom: 10, padding: 10 }}>
            <Dropdown label="Item / Labor" source={itemOrLabor} value={item.itemOrLabor} onChange={v => handleFieldChange(idx, 'itemOrLabor', v)} />
            <Input label="Qty" value={item.qty} onChange={v => handleFieldChange(idx, 'qty', v)} />
            <Input label="Cost to Lowes" value={item.costToLowes} error={costError} onChange={v => handleFieldChange(idx, 'costToLowes', v)} />
            {canViewPriceAdjustment && (
              <Input
                label="Price Adjustment"
                value={item.price_adjustment || ''}
                error={priceAdjustmentError}
                onChange={v => handleFieldChange(idx, 'price_adjustment', v)}
              />
            )}
            <Input label="Description" value={item.description} onChange={v => handleFieldChange(idx, 'description', v)} />
            <Button className={S.removeButton} label="Remove" onClick={() => removeRow(idx)} />
          </div>
        );
      })}
      <Button className={S.button} label="Add Item" onClick={addRow} />
    </div>
  );
}

LaborMaterial.propTypes = {
  labors_materials: PropTypes.arrayOf(
    PropTypes.shape({
      itemOrLabor: PropTypes.string,
      qty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      costToLowes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      description: PropTypes.string,
      price_adjustment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  onChange: PropTypes.func.isRequired,
  canViewPriceAdjustment: PropTypes.bool,
};

LaborMaterial.defaultProps = {
  canViewPriceAdjustment: true,
};

export default LaborMaterial;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/LaborMaterial.jsx